import React from 'react';
import { useExperimentsStore } from 'apps/experiments/src/store';
import { BannerReact } from 'common/components/banner';
import { BannerAction, BannerSize, BannerTheme, BannerType } from 'common/components/banner/types';
import { useTranslation } from 'common/i18n/hooks';
export function ExperimentsLimitBanner() {
  const {
    t
  } = useTranslation();
  const limit = useExperimentsStore(state => state.experimentsLimit);
  const [isClosed, setIsClosed] = React.useState(false);
  if (isClosed || limit === undefined) {
    return null;
  }
  return <BannerReact theme={BannerTheme.Info} type={BannerType.Embedded} size={BannerSize.Small} icon={"info"} ctas={[{
    text: "Dismiss",
    actionName: BannerAction.Dismiss
  }]} onAction={ev => ev.detail.actionName === BannerAction.Dismiss && setIsClosed(true)} data-sentry-element="BannerReact" data-sentry-component="ExperimentsLimitBanner" data-sentry-source-file="limit-banner.tsx">
      <div slot='body-text'>
        <span>
          {t("experiments.list.limit-banner", {
          limit
        })}
          {" "}
        </span>
        <a href={"https://mixpanel.com/contact-us/sales/"} target='_blank'>
          {t("common.learn-more")}
        </a>
      </div>
    </BannerReact>;
}